// FeatureFlagDeleteModal.jsx

import React from 'react';
import PropTypes from 'prop-types';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
  Stack,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { useTranslation } from 'react-i18next';
import { ModalView } from '../../../providers/modal.provider';

const FeatureFlagDeleteModal = ({ onClose, onConfirm, flagKey, loading = false }) => {
  const { t } = useTranslation();

  return (
    <ModalView
      fader='show'
      centered
      size='sm'
      onCloseEvent={onClose}
      
      
    >
      {/* HEADER */}
      <DialogTitle
        sx={{
          px: 3,
          py: 1.5,
        }}
      >
        <Stack direction='row' alignItems='center' justifyContent='space-between'>
          <Stack direction='row' alignItems='center'>
            <Box>
              <Typography
                variant='h6'
                sx={{
                  fontWeight: 700,
                  color: 'text.primary',
                }}
              >
                {t('deleteFeatureFlag')}
              </Typography>
            </Box>
          </Stack>

          {/* <IconButton
            onClick={onClose}
            disabled={loading}
            size='small'
            sx={{
              color: 'text.secondary',
            }}
          >
            <CloseIcon />
          </IconButton> */}
        </Stack>
      </DialogTitle>

      <Divider />

      {/* CONTENT */}
      <DialogContent
        sx={{
          px: 3,
          py: 2,
        }}
      >
        <Typography
          sx={{
            color: 'text.primary',
            fontSize: '15px',
          }}
        >
          {t('areYouSureYouWantToDeleteThis')}
        </Typography>

        {/* FLAG KEY CARD */}
        <Box
          sx={{
            mt: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            
            // borderRadius: '14px',
            // border: '1px solid',
            // borderColor: 'divider',
            // bgcolor: 'grey.50',
          }}
        >
          <Typography
            variant='caption'
            sx={{
              display: 'block', 
              color: 'text.secondary',
              fontWeight: 600,
              textTransform: 'uppercase',
              fontSize: '14px',
            }}
          >
            {t('key')}:
          </Typography>

          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 600,
              color: 'text.primary',
              wordBreak: 'break-word',
            }}
          >
            {flagKey}
          </Typography>
        </Box>
      </DialogContent>

      <Divider />

      {/* FOOTER */}
      <DialogActions
        sx={{
          px: 3,
          py: 1,
          gap: 1.5,
        }}
      >
        <Button
          variant='outlined'
          onClick={onClose}
          disabled={loading}
          fullWidth
          sx={{
            height: 44,
            borderRadius: '12px',
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '15px',
          }}
        >
          {t('cancel')}
        </Button>

        <Button
          color='error'
          variant='contained'
          onClick={onConfirm}
          disabled={loading}
          fullWidth
          sx={{
            height: 44,
            borderRadius: '12px',
            textTransform: 'none',
            fontWeight: 700,
            fontSize: '15px',
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none',
            },
          }}
        >
          {loading ? t('deleting') : t('delete')}
        </Button>
      </DialogActions>
    </ModalView>
  );
};

FeatureFlagDeleteModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  flagKey: PropTypes.string,
  loading: PropTypes.bool,
};

export default FeatureFlagDeleteModal;
